<template>
  <Layout>
    <div class="order-management-page">
      <div class="breadcrumb" style="background-color: transparent">
        <div class="breadcrumb-item">
          <span>{{ activityName }}</span>
        </div>
        <div class="breadcrumb-item-divider" style="padding: 0 4px">></div>
        <div class="breadcrumb-item" style="color: #1877ff; font-weight: bold">
          <span>订单管理</span>
        </div>
      </div>
      <!-- 顶部统计卡片 -->
      <div class="stats-cards">
        <div class="stat-card stat-card--blue">
          <div class="stat-label">实际收益</div>
          <div class="stat-value">¥{{ statsData.actualIncome }}</div>
        </div>
        <div class="stat-card stat-card--purple">
          <div class="stat-label">付费总额</div>
          <div class="stat-value">¥{{ statsData.totalAmount }}</div>
        </div>
        <div class="stat-card stat-card--red">
          <div class="stat-label">退款</div>
          <div class="stat-value">
            <span>{{ statsData.refundCount }}笔</span>
            <span class="stat-sub-value">¥{{ statsData.refundAmount }}元</span>
          </div>
        </div>
        <div class="stat-card stat-card--cyan">
          <div class="stat-label">报名数量</div>
          <div class="stat-value">{{ statsData.enrollCount }}笔</div>
        </div>
        <div class="stat-card stat-card--pink">
          <div class="stat-label">报名人数</div>
          <div class="stat-value">{{ statsData.enrollUserCount }}人</div>
        </div>
      </div>

      <!-- Tab 切换栏 -->
      <div class="tab-section">
        <div class="tab-list">
          <div
            v-for="(tab, index) in tabList"
            :key="index"
            :class="['tab-item', { active: currentTab === index }]"
            @click="handleTabChange(index)"
          >
            {{ tab.name }}
            <span v-if="tab.count !== undefined" class="tab-count">
              ({{ tab.count }}人)
            </span>
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="search-section">
          <div class="search-item">
            <i
              class="el-icon-search"
              style="
                font-size: 16px;
                margin-left: 10px;
                margin-top: 8px;
                color: #8e89aa;
              "
            ></i>
            <el-input
              v-model="keyword"
              placeholder="输入搜索关键词"
              class="input-with-search"
              clearable
              @keyup.enter.native="handleSearch"
            >
            </el-input>
            <el-button
              icon="el-icon-search"
              class="search-button"
              @click="handleSearch"
            ></el-button>
          </div>
        </div>
      </div>

      <!-- 订单列表 -->
      <div class="order-list-section">
        <div class="list-header">
          <span class="list-title">已参与</span>
          <span class="list-count"> ({{ pagination.total }}人) </span>
          <!-- <span class="list-action">
            <el-button type="text" @click="handleOrderManagement">
              订单管理
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </span> -->
        </div>

        <div class="order-list">
          <div v-for="item in orderList" :key="item.id" class="order-item">
            <!-- 用户信息行 -->
            <div class="user-info">
              <img
                :src="item.userAvatar || defaultAvatar"
                alt="avatar"
                class="avatar"
                @click="goToDetail(item)"
              />
              <div class="user-detail">
                <div class="user-name-row">
                  <div class="name-status-wrap">
                    <span class="nickname" @click="goToDetail(item)">{{
                      item.userName
                    }}</span>
                    <span
                      :class="['status-tag', getStatusClass(item.orderStatus)]"
                    >
                      {{ getStatusText(item.orderStatus) }}
                    </span>
                  </div>
                  <span class="order-no">#{{ item.serialNumber }}</span>
                </div>
                <div class="user-meta-row">
                  <div class="meta-left">
                    <span class="user-id">ID: {{ item.userKey }}</span>
                    <span class="join-time"
                      >接龙时间：{{ formatTime(item.participateTime) }}</span
                    >
                  </div>
                  <div class="meta-right" v-if="item.orderStatus === 4">
                    <div
                      class="comfirm-btn"
                      @click="handlerConfirmRefund(item)"
                    >
                      同意退款
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 退款原因 - 仅在待退款状态显示 -->
            <div
              v-if="item.orderStatus === 4 && item.refundReason"
              class="refund-reason-box"
            >
              <span class="refund-reason-text">
                申请退款原因：{{ item.refundReason }}
              </span>
            </div>

            <!-- 费用明细 -->
            <div class="fee-section">
              <div class="fee-item">
                <span class="fee-name">付费项：{{ item.goodName }}</span>
              </div>
              <div class="fee-total-row">
                <span class="fee-total-label">合计金额：</span>
                <span class="fee-total-amount"
                  >¥{{ item.actualPayAmount }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!loading && orderList.length === 0" class="empty-state">
          <img
            src="https://ossfastmake.mustke.com/12jielong/bdJL/no-data.png"
            alt="无数据"
            class="empty-image"
          />
          <p class="empty-text">暂无相关数据</p>
        </div>

        <!-- 分页 -->
        <div v-if="orderList.length > 0" class="pagination-section">
          <el-pagination
            :current-page="pagination.pageNum"
            :page-size="pagination.pageSize"
            :total="pagination.total"
            layout="total, prev, pager, next"
            @current-change="handlePageChange"
          />
        </div>
      </div>

      <!-- 底部导出按钮 -->
      <div class="bottom-action">
        <el-button type="primary" class="export-btn" @click="handleExport">
          导出数据
        </el-button>
      </div>

      <el-dialog
        title="筛选导出范围"
        :visible.sync="filterTimesBoxShow"
        width="450px"
        :before-close="cancelSort"
      >
        <div class="s-times-box" style="margin: -20px 0">
          <div
            class="times-item"
            v-for="item in timeFilterArr"
            :key="item.type"
            :class="{ 'times-item-active': item.active == true }"
            @click="currentSelect(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="sort-box">
          <div class="sort-title">自定义时间</div>
          <div class="timeRangeOutBox flex-depart-center">
            <el-date-picker
              v-model="startQueryTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期"
            >
            </el-date-picker>
            <span style="padding-left: 10px; padding-right: 10px">-</span>
            <el-date-picker
              v-model="endQueryTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="选择日期"
            >
            </el-date-picker>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelSort">取 消</el-button>
          <el-button type="primary" @click="submitFn">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="导出订单数据"
        :visible.sync="exportResultShow"
        width="500px"
        :before-close="cancelOrderResult"
      >
        <div class="exporOrderResult-page">
          <div class="tip-wrap">
            <div
              class="tip-url"
              style="
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              "
            >
              导出链接： {{ exportDataInfo.downloadUrl }}
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleRegenerate" type="info"
            >重新生成链接</el-button
          >
          <el-button type="success" @click="handleCopyDownloadUrl"
            >复制下载链接</el-button
          >
          <el-button @click="cancelOrderResult" type="primary"
            >下载文件</el-button
          >
        </span>
      </el-dialog>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import {
  getOrderStatistics,
  getOrderList,
  orderAuditRefund,
} from "@/utils/api/wallet.js";
import {
  allowExport,
  orderListByChoose,
  selFileLink,
} from "@/utils/api/activity.js";

const DEFAULT_AVATAR =
  "https://ossfastmake.mustke.com/12jielong/bdJL/default-avatar.png";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "订单管理",
  },
  name: "OrderManagement",
  components: { Layout },
  data() {
    return {
      exportDataInfo: {
        downloadUrl: "",
      },
      exportResultShow: false,
      loadingInstance: null,
      timer: null,
      startQueryTime: "",
      endQueryTime: "",
      timeValue: "自定义日期",
      startTime: "",
      endTime: "",
      timeFilterArr: [
        {
          title: "全部",
          active: true,
          type: 0,
        },
        {
          title: "今天",
          active: false,
          type: 1,
        },
        {
          title: "昨天",
          active: false,
          type: 2,
        },
        {
          title: "最近三天",
          active: false,
          type: 3,
        },
        {
          title: "本周",
          active: false,
          type: 4,
        },
        {
          title: "上周",
          active: false,
          type: 5,
        },
        {
          title: "本月",
          active: false,
          type: 6,
        },
        {
          title: "上月",
          active: false,
          type: 7,
        },
      ],
      filterTimesBoxShow: false,
      loading: false,
      // 统计数据
      statsData: {
        actualIncome: 0,
        totalAmount: 0,
        refundCount: 0,
        refundAmount: 0,
        enrollCount: 0,
        enrollUserCount: 0,
      },
      // Tab 列表 - orderStatus: 1-待支付，2-未完成，3-已完成，4-待退款，5-已取消
      // 1-待支付, 2-未完成, 3-已完成, 4-待退款, 5-已取消, 6-退款失败, 7-支付失败
      tabList: [
        { name: "全部", status: "" },
        { name: "待支付", status: 1 },
        { name: "已取消", status: 5 },
        { name: "待退款", status: 4 },
        { name: "未完成", status: 2 },
        { name: "已完成", status: 3 },
      ],
      currentTab: 0,
      // 搜索关键词
      keyword: "",
      // 订单列表
      orderList: [],
      // 分页
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      currentRefundItem: null,
      // 默认头像
      defaultAvatar: DEFAULT_AVATAR,
      // 活动 ID（从路由参数获取）
      activityId: "",
      activityName: "",
    };
  },
  computed: {
    currentStatus() {
      return this.tabList[this.currentTab]?.status;
    },
  },
  created() {
    // 从路由参数获取活动 ID
    const query = this.$route.query;
    this.activityId = query.id || query.activityId;
    this.activityName = query.activityName || "";
    console.log("[OrderManagement] activityId:", this.activityId);
  },
  mounted() {
    this.setPageTitle();
    if (this.activityId) {
      this.loadStatistics();
      this.fetchOrderList();
    }
  },
  methods: {
    /**
     * 复制下载链接
     */
    handleCopyDownloadUrl() {
      const url = this.exportDataInfo.downloadUrl;
      if (!url) {
        this.$message.warning("暂无下载链接");
        return;
      }
      const textarea = document.createElement("textarea");
      textarea.value = url;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand("copy");
        this.$message.success("下载链接已复制");
      } catch {
        this.$message.error("复制失败，请手动复制");
      }
      document.body.removeChild(textarea);
    },
    /**
     * 重新生成链接
     */
    handleRegenerate() {
      this.exportResultShow = false;
      this.resetTimeSelection();
      this.filterTimesBoxShow = true;
    },
    /**
     * 重置时间选择状态
     */
    resetTimeSelection() {
      this.startTime = "";
      this.endTime = "";
      this.startQueryTime = "";
      this.endQueryTime = "";
      this.startTimeValue = Number(new Date());
      this.endTimeValue = Number(new Date());
      this.timeValue = "自定义日期";
      // 重置时间筛选选项
      this.timeFilterArr.forEach((v, index) => {
        v.active = index === 0;
      });
    },
    cancelOrderResult() {
      this.exportResultShow = false;
    },
    cancelSort() {
      this.filterTimesBoxShow = false;
      this.resetTimeSelection();
    },
    async submitFn() {
      // 验证时间字段
      if (this.startQueryTime || this.endQueryTime) {
        if (!this.startQueryTime || !this.endQueryTime) {
          this.$message("开始时间和结束时间必须同时填写");
          return;
        }

        // 将时间字符串转换为时间戳进行比较
        const startTime = new Date(this.startQueryTime).getTime();
        const endTime = new Date(this.endQueryTime).getTime();

        if (startTime > endTime) {
          this.$message("开始时间不能大于结束时间");
          return;
        }
      }
      this.filterTimesBoxShow = false;

      try {
        // 检查是否允许导出
        const res = await allowExport({
          activityId: this.activityId,
          startQueryTime: this.startQueryTime,
          endQueryTime: this.endQueryTime,
          type: 4,
        });

        if (res.status === 0) {
          this.$message.error(res.msg);
          return;
        }
        this.loadingInstance = this.$loading({
          lock: true,
          text: "处理中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        // 发起导出请求
        this.exportData();

        // 轮询查询导出结果
        this.startPolling();
      } catch (error) {
        console.error("导出失败", error);
        this.loadingInstance?.close();
        this.$message.error(error.message || "导出失败");
      }
    },
    /**
     * 发起导出请求
     */
    exportData() {
      const resultInfo = {
        condition: this.startQueryTime
          ? this.startQueryTime + " - " + this.endQueryTime
          : "全部",
      };
      orderListByChoose({
        activityId: this.activityId,
        exportType: 5,
        isDownLoad: 0,
        exportOrder: 1,
        exportMethod: 1,
        startQueryTime: this.startQueryTime,
        endQueryTime: this.endQueryTime,
        type: 4,
        screeningScope: JSON.stringify(resultInfo),
        userId: localStorage.getItem("userID"),
      });
    },

    /**
     * 开始轮询查询导出结果
     */
    startPolling() {
      this.stopPolling(); // 先清除之前的定时器

      this.timer = setInterval(async () => {
        try {
          const res = await selFileLink({ activityId: this.activityId });

          if (res.status === 1 && res.data && res.data.length > 0) {
            const orderExportRecord = res.data.find(
              (item) => item.linkType === 4,
            );
            if (orderExportRecord && orderExportRecord.fileUrl) {
              this.stopPolling();
              this.loadingInstance?.close();

              // 更新导出结果信息
              this.exportDataInfo = {
                downloadUrl: orderExportRecord.fileUrl,
                condition: orderExportRecord.screeningScope
                  ? JSON.parse(orderExportRecord.screeningScope).condition
                  : "全部",
                createdTime: orderExportRecord.addTime,
              };

              // 显示结果弹层
              this.exportResultShow = true;
            }
          }
        } catch (error) {
          console.error("查询导出结果失败", error);
        }
      }, 1000);
    },

    /**
     * 停止轮询
     */
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    currentSelect(item) {
      console.log(item.type, "typene");
      this.timeFilterArr.forEach((v) => (v.active = false));
      item.active = true;

      const padZero = (n) => n.toString().padStart(2, "0");
      const format = (date) =>
        `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(
          date.getDate(),
        )}`;

      const today = new Date();
      let start, end;

      switch (item.type) {
        case 0: // 全部
          this.startTime = "";
          this.endTime = "";
          this.timeValue = "自定义日期";
          this.startQueryTime = "";
          this.endQueryTime = "";
          return;

        case 1: // 今天
          start = end = today;
          break;

        case 2: // 昨天
          var yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          start = end = yesterday;
          break;

        case 3: // 最近三天
          start = new Date(today);
          start.setDate(today.getDate() - 2);
          end = today;
          break;

        case 4: // 本周（周一到周日）
          start = new Date(today);
          // 计算到本周一的差值（当today.getDay()=1(周一)时，差0天）
          var dayDiff = (today.getDay() + 6) % 7;
          start.setDate(today.getDate() - dayDiff);
          end = new Date(start);
          end.setDate(start.getDate() + 6);
          break;

        case 5: // 上周（周一到周日）
          // 先找到本周一
          var thisMonday = new Date(today);
          thisMonday.setDate(today.getDate() - ((today.getDay() + 6) % 7));
          // 上周日是本周一减1天
          end = new Date(thisMonday);
          end.setDate(thisMonday.getDate() - 1);
          // 上周一是上周日减6天
          start = new Date(end);
          start.setDate(end.getDate() - 6);
          break;

        case 6: // 本月（1号到当月最后一天）
          start = new Date(today.getFullYear(), today.getMonth(), 1);
          end = new Date(today.getFullYear(), today.getMonth() + 1, 0); // 关键修改点
          break;

        case 7: // 上月
          start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          end = new Date(today.getFullYear(), today.getMonth(), 0);
          break;
      }

      this.startTime = format(start);
      this.endTime = format(end);

      this.startQueryTime = this.startTime;
      this.endQueryTime = this.endTime;

      this.timeValue = this.startQueryTime + " ~ " + this.endQueryTime;
    },
    async handlerConfirmRefund(item) {
      this.$confirm(
        "请确认是否同意该订单的退款申请？退款后，报名费将原路退回至参与者支付账户。",
        "退款操作确认",
        {
          confirmButtonText: "同意退款",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(async () => {
          // 调用同意退款接口
          const res = await orderAuditRefund({
            orderIds: [item.id],
            aggree: true,
          });
          if (res.status === 1) {
            // // 请求成功，前端乐观更新：将该订单标记为已同意
            // this.agreedOrderIds.push(orderId);
            this.$message.success("操作成功");
            this.fetchOrderList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => {
          this.$message.info("已拒绝退款");
        });
    },
    goToDetail(item) {
      this.$router.push({
        path: "/orderManagementDetail",
        query: { id: item.id },
      });
    },
    // 设置页面标题
    setPageTitle() {
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }
      document.title = `订单管理 - ${suffix}`;
      console.log(document.title, "document.title");
    },

    // 加载统计数据
    async loadStatistics() {
      if (!this.activityId) return;
      try {
        const res = await getOrderStatistics(this.activityId);
        if (res.status === 1 && res.data) {
          this.statsData = {
            actualIncome: res.data.actualIncome || 0,
            totalAmount: res.data.totalAmount || 0,
            refundCount: res.data.refoundCount || 0,
            refundAmount: res.data.refundAmount || 0,
            enrollCount: res.data.enrollCount || 0,
            enrollUserCount: res.data.enrollUserCount || 0,
          };
        }
      } catch (error) {
        console.error("获取统计数据失败:", error);
      }
    },

    // 获取订单列表
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          orderStatus: this.currentStatus,
          userName: this.keyword,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          activityId: this.activityId,
        };
        console.log("[OrderManagement] fetchOrderList params:", params);

        const res = await getOrderList(params);
        console.log("[OrderManagement] fetchOrderList response:", res);

        if (res.status === 1) {
          this.orderList = (res.data.list || []).map((item) => ({
            ...item,
            refundAgreed: false,
          }));
          this.pagination.total = res.data.total || 0;
        }
      } catch (error) {
        console.error("获取订单列表失败:", error);
        this.$message.error("加载数据失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // Tab 切换
    handleTabChange(index) {
      if (this.currentTab === index) return;
      this.currentTab = index;
      this.pagination.pageNum = 1;
      this.fetchOrderList();
    },

    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.fetchOrderList();
    },

    // 分页变化
    handlePageChange(page) {
      this.pagination.pageNum = page;
      this.fetchOrderList();
    },

    // 订单管理按钮点击
    handleOrderManagement() {
      // 跳转到订单管理页面或打开相关弹窗
      console.log("订单管理按钮点击");
    },

    // 导出数据
    async handleExport() {
      console.log(this.activityName, "activityName");
      console.log(this.activityId, "activityId");

      try {
        this.loadingInstance = this.$loading({
          lock: true,
          text: "处理中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const res = await selFileLink({ activityId: this.activityId });
        this.loadingInstance?.close();

        if (res.status === 1 && res.data && res.data.length > 0) {
          // 找到 linkType === 4 的订单导出记录
          const orderExportRecord = res.data.find(
            (item) => item.linkType === 4,
          );
          if (orderExportRecord && orderExportRecord.fileUrl) {
            // 已有导出记录，直接显示结果弹层
            this.exportDataInfo = {
              downloadUrl: orderExportRecord.fileUrl,
              condition: orderExportRecord.screeningScope
                ? JSON.parse(orderExportRecord.screeningScope).condition
                : "全部",
              createdTime: orderExportRecord.addTime,
            };
            this.exportResultShow = true;
            return;
          }
        }
        // 没有导出记录，显示时间选择弹窗
        this.filterTimesBoxShow = true;
      } catch (error) {
        this.loadingInstance?.close();
        console.error("查询导出记录失败", error);
        // 出错时也显示时间选择弹窗
        this.filterTimesBoxShow = true;
      }
    },

    // 获取状态样式类
    getStatusClass(status) {
      const statusMap = {
        1: "status-pending-pay", // 待支付
        2: "status-pending-complete", // 未完成
        3: "status-completed", // 已完成
        4: "status-pending-refund", // 待退款
        5: "status-canceled", // 已取消
        6: "status-refund-failed", // 退款失败
        7: "status-pay-failed", // 支付失败
        8: "status-canceled", // 已退款
      };
      return statusMap[status] || "";
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        1: "待支付",
        2: "未完成",
        3: "已完成",
        4: "待退款",
        5: "已取消",
        6: "退款失败",
        7: "支付失败",
        8: "已退款",
      };
      return textMap[status] || "";
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      if (isNaN(date.getTime())) return time;
      return date.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
  destroyed() {
    this.stopPolling();
  },
};
</script>

<style lang="scss" scoped>
.order-management-page {
}

// 统计卡片区域
.stats-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;

  .stat-card {
    flex: 1;
    padding: 20px;
    border-radius: 8px;
    color: #fff;
    min-width: 150px;

    .stat-label {
      font-size: 18px;
      opacity: 0.9;
      margin-bottom: 8px;
    }

    .stat-value {
      font-size: 28px;
      font-weight: bold;

      .stat-sub-value {
        margin-left: 8px;
        // font-size: 18px;
      }
    }

    &--blue {
      background: linear-gradient(180deg, #317af7, #84b0fe);
    }

    &--purple {
      background: linear-gradient(180deg, #3a41ef, #888cf7);
    }

    &--red {
      background: linear-gradient(180deg, #fe3b21, #f47171);
    }

    &--cyan {
      background: linear-gradient(90deg, #37b4c8, #4fcde0);
    }

    &--pink {
      background: linear-gradient(136deg, #ae31f7, #ca6fff 98%);
    }
  }
}

// Tab 区域
.tab-section {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tab-list {
    display: flex;
    gap: 8px;

    .tab-item {
      padding: 8px 16px;
      font-size: 16px;
      color: #a7adc6;
      cursor: pointer;
      border-radius: 4px;
      transition: all 0.3s;
      position: relative;

      &:hover {
        color: #409eff;
        background-color: #f5f7fa;
      }

      &.active {
        color: #323b5a;
        font-weight: bold;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 40%;
          height: 3px;
          background: #409eff;
          border-radius: 2px;
        }
      }

      .tab-count {
        color: #999;
        font-weight: normal;
        font-size: 12px;
      }
    }
  }

  .search-section {
    display: flex;
    align-items: center;

    .search-item {
      background-color: #f8f8f8;
      height: 30px;
      border-radius: 20px;
      display: flex;
      overflow: hidden;

      :deep(.el-input__inner) {
        height: 30px;
        line-height: 30px;
        border: 0px solid #dcdfe6;
        background-color: #f8f8f8;
      }

      :deep(.el-input__suffix) {
        top: -4px;
      }
    }

    .search-button {
      width: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background-color: #1877ff;
      font-size: 16px;
      color: white;
      border-radius: 30px;
      text-align: center;
      line-height: 30px;
    }

    .input-with-search {
      width: 255px;

      :deep(.el-input__inner) {
        border: 0px solid #dcdfe6;
        background-color: #f8f8f8;
      }
    }
  }
}

// 订单列表区域
.order-list-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 440px;

  .list-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;

    .list-title {
      font-size: 16px;
      font-weight: bold;
      color: #323b5a;
    }

    .list-count {
      font-size: 14px;
      color: #1877ff;
      margin-left: 8px;
    }

    .list-action {
      margin-left: auto;

      .el-button {
        font-size: 14px;
        color: #409eff;
      }
    }
  }

  .order-list {
    .order-item {
      padding: 20px;
      border-bottom: 1px solid #ebeef5;

      &:last-child {
        border-bottom: none;
      }

      .user-info {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;

        .avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin-right: 12px;
          object-fit: cover;
          cursor: pointer;
        }

        .user-detail {
          flex: 1;

          .user-name-row {
            display: flex;
            align-items: flex-start;
            margin-bottom: 6px;

            .name-status-wrap {
              flex: 1;
              display: flex;
              align-items: center;
              gap: 8px;

              .nickname {
                cursor: pointer;
                font-size: 16px;
                font-weight: bold;
                color: #303133;
              }

              .status-tag {
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 12px;
                font-weight: bold;

                &.status-pending-pay {
                  background: #fff7e6;
                  color: #ff9500;
                }

                &.status-pending-complete {
                  background: #e6f7ff;
                  color: #1890ff;
                }

                &.status-completed {
                  background: #e8f5e9;
                  color: #67c23a;
                }

                &.status-pending-refund {
                  background: #ffebee;
                  color: #f56c6c;
                }

                &.status-canceled {
                  background: #f5f5f5;
                  color: #909399;
                }
              }
            }

            .order-no {
              font-size: 14px;
              color: #303133;
              font-weight: bold;
            }
          }

          .user-meta-row {
            font-size: 13px;
            color: #909399;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .meta-right {
              font-size: 16px;
              color: #fff;
              background-color: #1877ff;
              padding: 6px 17px;
              border-radius: 6px;
              cursor: pointer;
              transition: all 0.3s ease-in-out;
              &:hover {
                opacity: 0.8;
              }
            }

            .user-id {
              margin-right: 16px;
            }
          }
        }
      }

      .refund-reason-box {
        background: #eef5ff;
        border-radius: 6px;
        padding: 10px 16px;
        margin-bottom: 12px;

        .refund-reason-text {
          font-size: 13px;
          color: #409eff;
          word-break: break-all;
        }
      }

      .fee-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .fee-item {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .fee-name {
            font-size: 14px;
            color: #606266;
          }
        }

        .fee-total-row {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .fee-total-label {
            font-size: 14px;
            color: #606266;
            margin-right: 8px;
          }

          .fee-total-amount {
            font-size: 18px;
            font-weight: bold;
            color: #f56c6c;
          }
        }
      }

      .action-row {
        display: flex;
        justify-content: flex-end;
        margin-top: 12px;
      }
    }
  }

  .empty-state {
    text-align: center;
    padding: 60px 20px;

    .empty-image {
      width: 200px;
      height: auto;
      margin-bottom: 16px;
    }

    .empty-text {
      font-size: 14px;
      color: #909399;
    }
  }

  .pagination-section {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }
}

// 底部导出按钮
.bottom-action {
  text-align: center;
  padding: 20px;

  .export-btn {
    // width: 200px;
    // height: 44px;
    // font-size: 16px;
    // border-radius: 22px;
    width: 436px;
    height: 66px;
    background: #1877ff;
    border-radius: 33px;
    font-size: 21px;
  }
}
.s-times-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 5px;
}
.times-item {
  width: 80px;
  height: 30px;
  background: rgba(24, 119, 255, 0.05);
  border: 0.5px solid rgba(24, 119, 255, 0.2);
  color: #1877ff;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin: 5px 3px;
  font-size: 13px;
}

.times-item-active {
  background-color: #1877ff;
  color: #fff;
}
.timeRangeOutBox .el-date-editor.el-input {
  width: 178px;
}

.sort-box {
  width: 94%;
  margin: 0 auto;
  padding: 15px 0px;
}

.sort-title {
  font-size: 15px;
  color: #555555;
  margin-bottom: 10px;
  font-weight: bold;
}

.nextBtn {
  width: 94%;
  margin: 0 auto;
  height: 50px;
  background: #1877ff;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 50px;
}

.s-times-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 5px;
}

.times-item {
  width: 80px;
  height: 30px;
  background: rgba(24, 119, 255, 0.05);
  border: 0.5px solid rgba(24, 119, 255, 0.2);
  color: #1877ff;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  margin: 5px 3px;
  font-size: 13px;
}

.times-item-active {
  background-color: #1877ff;
  color: #fff;
}

.timeRangeBox {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  margin-top: 10px;
  background: #f7f7f7;
  border: 1px solid #dcdde0;
  border-radius: 4px;
  color: #7e7e81;
}

.dc-btns {
  height: 45px;
  border-top: 1px solid #eee;
  display: flex;
}

.dc-items {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn1 {
  color: #1877ff;
}

.btn2 {
  background-color: #1877ff;
  color: white;
}
</style>
